/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditDisciplineSubgroupDTO
 */
export interface EditDisciplineSubgroupDTO {
    /**
     * 
     * @type {string}
     * @memberof EditDisciplineSubgroupDTO
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditDisciplineSubgroupDTO
     */
    subjectIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EditDisciplineSubgroupDTO
     */
    groupId?: string;
}

export function EditDisciplineSubgroupDTOFromJSON(json: any): EditDisciplineSubgroupDTO {
    return EditDisciplineSubgroupDTOFromJSONTyped(json, false);
}

export function EditDisciplineSubgroupDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditDisciplineSubgroupDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'subjectIds': !exists(json, 'subjectIds') ? undefined : json['subjectIds'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
    };
}

export function EditDisciplineSubgroupDTOToJSON(value?: EditDisciplineSubgroupDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'subjectIds': value.subjectIds,
        'groupId': value.groupId,
    };
}

